//back to this
import { Tabs } from "antd";
import { useEffect } from "react";
import { MyBookings } from "./molecules/myBookings";

import getCurrentUser from "../../../utils/getCurrentUser";

function ProfileTemplate() {
  const user = getCurrentUser();
  useEffect(() => {
    if (!user) {
      window.location.href = "/login";
    }
  }, [user]);

  return (
    <div className="mt-5 ms-5">
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            label: "Profile",
            key: "1",
            children: (
              <>
                <h1>My Profile</h1>
                <br />
                <p>Name: {user.name}</p>
                <p>Email: {user.email}</p>
                <p>Admin Role: {user.isAdmin ? "Yes" : "No"}</p>
              </>
            ),
          },
          {
            label: "Bookings",
            key: "2",
            children: <MyBookings />,
          },
        ]}
      />
    </div>
  );
}

export default ProfileTemplate;
